package com.evoapps.evoshift.data.dto.system

import kotlinx.serialization.Serializable

@Serializable
data class MetadataDto(
    val createdAt: String,
    val createdBy: String,
    val updatedAt: String? = null,
    val updatedBy: String? = null
)
